import { lazy } from 'solid-js'
import { messages } from '../../pages/verification-result-page/verification-result-page-routing.messages.en.js'

const VerificationResultPage = lazy(() => import('../../pages/verification-result-page/verification-result-page.jsx'))

export default {
    component: VerificationResultPage,
    name: 'VerificationResultPage',
    path: '/property/:property_id/verify/results',
    showFooter: false,
    showHeaderMenu: false,
    showSidebar: true,
    titleMessage: messages.titleMessage,
}

